
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class extends Vue {
  @Prop({ default: 'fas fa-question-circle' })
  icon!: string;
  @Prop({ default: 'Are you sure?' })
  message!: string;
  @Prop({ default: false })
  value!: boolean;

  onConfirm() {
    this.$emit('confirm');
    this.$emit('input', false);
  }
}
